import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {EntityTailConfig} from '../../../core/models/EntityTailConfig';
import {LegalEntity} from '../../../core/models/LegalEntity';
import * as _ from 'underscore';

@Component({
    selector: 'app-time-range-tail-config',
    templateUrl: './time-range-tail-config.component.html',
    styleUrls: ['./time-range-tail-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimeRangeTailConfigComponent implements OnInit {
    @Input()
    entityTailConfig: EntityTailConfig;

    @Input()
    entityList: LegalEntity[];

    @Output() copyToAnotherEntity = new EventEmitter<string>();

    copyTo: string;
    entityListWithoutCurrentEntity: LegalEntity[];

    constructor() {
    }

    ngOnInit() {
        this.entityListWithoutCurrentEntity = _.filter(this.entityList, x => {
            return x.name !== this.entityTailConfig.legalEntity.name;
        }) ;
    }

    onRemoveModelTimeRangeTail(index) {
        this.entityTailConfig.yearRangeTails.splice(index, 1);
        if (index > this.entityTailConfig.yearRangeTails.length - 1) {
            this.entityTailConfig.yearRangeTails[index - 1].to = 120;
            return;
        }

        if (index - 1 >= 0 && this.entityTailConfig.yearRangeTails.length - 1 >= index) {
            this.onItemToChange(this.entityTailConfig.yearRangeTails[index - 1].to, index - 1);
        }
    }

    addTimePeriod() {
        const length = this.entityTailConfig.yearRangeTails.length;
        if (length >= 1 && (this.entityTailConfig.yearRangeTails[length - 1].to == null ||
                this.entityTailConfig.yearRangeTails[length - 1].from == null ||
                this.entityTailConfig.yearRangeTails[length - 1].tail == null)) {
            return;
        }
        const newTail = {...this.entityTailConfig.yearRangeTails[0]};
        newTail.from = this.entityTailConfig.yearRangeTails[length - 1].to;
        newTail.to = 120;
        newTail.tail = 0.02;

        this.entityTailConfig.yearRangeTails.push(newTail);
    }

    onItemToChange(value, index) {
        if (!this.entityTailConfig.yearRangeTails[index + 1]) {
            return;
        }

        this.entityTailConfig.yearRangeTails[index + 1].from = value;
    }

    onCopyToAnotherEntity(copyTo) {
        if (!copyTo || copyTo === '') {
            return;
        }

        this.copyToAnotherEntity.emit(copyTo);
        this.copyTo = null;
    }

}
